import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ConsentDataClient } from './services/consent-data-client';
import { ConsentState } from './services/consent-state';

export const consentGuard: CanActivateFn = async () => {
  const consentState = inject(ConsentState);
  const consentClient = inject(ConsentDataClient);

  if (consentState.hasConsented()) return true;

  consentState.setLoading(true);

  try {
    const response = await lastValueFrom(consentClient.getConsentStatus());

    if (response.isConsentGiven) {
      consentState.setHasConsented(true);
      return true;
    }

    consentState.openDialog();
    return false;
  } catch {
    consentState.openDialog();
    return false;
  } finally {
    consentState.setLoading(false);
  }
};
